import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Menu, MenuItem } from '@sm/wds-react';
import { TabletScreen } from '../../..';
import userDataQuery from './UserDataQuery';
import './user-drop-down.scss';

const UserDropDownTrigger = username => {
  const usernametrunc =
    username.length > 15 ? `${username.substring(0, 9)}...` : username;
  return (
    <Button
      size="sm"
      variant="text"
      className="sm-user-drop-down--button sm-user-drop-down--text"
    >
      <div className="sm-user-drop-down--username">{usernametrunc}</div>
      <Icon>–</Icon>
    </Button>
  );
};

const getUserDropDown = (username, userLinks) => {
  return (
    <div className="sm-user-drop-down--menu-container">
      <Menu
        placement="bottom-right"
        noRules
        dense
        menuTrigger={UserDropDownTrigger(username)}
      >
        {userLinks.map(item => {
          return (
            <a
              key={`${item.name}-userMenu`}
              href={item.path}
              className="sm-user-drop-down--menu-link "
            >
              <MenuItem>{item.name}</MenuItem>
            </a>
          );
        })}
      </Menu>
    </div>
  );
};

const UserDropDown = ({ lang, isEUDC }) => (
  <>
    <TabletScreen>{userDataQuery(lang, isEUDC, getUserDropDown)}</TabletScreen>
  </>
);

UserDropDown.propTypes = {
  lang: PropTypes.string,
  isEUDC: PropTypes.bool.isRequired
};

UserDropDown.defaultProps = {
  lang: 'en'
};

export default UserDropDown;
